<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('defaultCommission.dealerType') }}</label>
            <a-select 
              v-model="model.dealer_type_id" 
              class="ts-w-full" 
              :options="dealer_types"
              :disabled="isEdit"
            ></a-select>
            <div class="validate ts-text-xs" v-if="errors.has('dealer_type_id')">
              {{ errors.first('dealer_type_id') }}
            </div>
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('defaultCommission.topUpRate') }}</label>
            <input type="number" v-model.number="model.topup_commission_rate" class="form-control">
            <div class="validate ts-text-xs" v-if="errors.has('topup_commission_rate')">
              {{ errors.first('topup_commission_rate') }}
            </div>
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('defaultCommission.payoutRate') }}</label>
            <input type="number" v-model.number="model.payout_comission_rate" class="form-control">
            <div class="validate ts-text-xs" v-if="errors.has('payout_comission_rate')">
              {{ errors.first('payout_comission_rate') }}
            </div>
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('defaultCommission.creditAllow') }}</label>
            <input type="number" v-model.number="model.credit_allow" class="form-control">
            <div class="validate ts-text-xs" v-if="errors.has('credit_allow')">
              {{ errors.first('credit_allow') }}
            </div>          
        </div>
      </div>
      <div class="row ts-mt-2">
        <div class="col-md-12">
            <label class="ts-text-xs required">{{ $t('defaultCommission.payoutLimit') }}</label>
            <input type="number" v-model.number="model.payout_limit" class="form-control">
            <div class="validate ts-text-xs" v-if="errors.has('payout_limit')">
              {{ errors.first('payout_limit') }}
            </div>            
        </div>
      </div>
      <div class="row ts-mt-6">
        <div class="col-md-12 ts-text-right">
          <ts-button
            @click.prevent="$emit('cancel')"
          >{{ $t('cancel') }}</ts-button>
          <ts-button
            v-if="!isEdit"
            color="primary"
            outline
            class="ts-mx-2"
            :waiting="waiting_new"
            @click.prevent="onSaveNew"
          >{{ $t('save_add_new') }}</ts-button>
          <ts-button
            color="primary"
            :class="isEdit ? 'ts-ml-2': ''"
            :waiting="waiting"
            @click.prevent="onStore"
          >
            <span v-if="isEdit">{{ $t('update') }}</span>
            <span v-else>{{ $t('save') }}</span>
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'defaultCommission',
  props: ['editData'],
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      loading: false,
      dealer_types: [],
      model: {
        dealer_type_id: '',
        topup_commission_rate: '',
        payout_comission_rate: '',
        credit_allow: '',
        payout_limit: ''
      }
    }
  },
  created(){
    this.fetchData()
    this.setEditData()
  },
  computed: {
    isEdit() {
      return this.editData != null
    }
  },
  methods: {
    ...mapActions('accounting/defaultCommission', ['store', 'dealerType']),
    fetchData(){
      this.loading = true
      this.dealerType()
        .then(response => {
          this.dealer_types = response.data.map(el => ({
            value: el.dealer_type_id,
            label: el.dealer_type
          }))
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onStore(){
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(err => {
          this.errors = new Errors(err.errors)
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew(){
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(err => {
          this.errors = new Errors(err.errors)
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput(){
      this.model.dealer_type_id = ''
      this.model.topup_commission_rate = ''
      this.model.payout_comission_rate = ''
      this.model.credit_allow = ''
      this.model.payout_limit = ''
    },
    setEditData(){
      if(this.isEdit){
        this.model.dealer_type_id = this.editData.dealer_type_id
        this.model.topup_commission_rate = this.editData.topup_commission_rate
        this.model.payout_comission_rate = this.editData.payout_comission_rate
        this.model.credit_allow = this.editData.credit_allow
        this.model.payout_limit = this.editData.payout_limit
      }
    }
  }
}
</script>